import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import useGlynt from './useGlynt';

type ParamTypes = {
  groupId: string;
  group: 'train' | 'extract';
  limit: number;
  dpId: string;
};
export default function usePaginatedDocuments({ groupId, group, limit = 100, dpId }: ParamTypes) {
  const [page, setPage] = useState(0);
  const glynt = useGlynt(dpId);
  let queryParams =
    group === 'train'
      ? {
          advanced: true,
          ordering: '-created_at',
          limit,
          offset: page * limit,
          training_set: groupId,
        }
      : {
          advanced: true,
          limit,
          offset: page * limit,
          extraction_batch: groupId,
        };
  const { data, isError, isPending, isFetching, refetch } = useQuery({
    queryKey: ['documents', { page, limit, group, groupId }],
    queryFn: async () => (await glynt).document.list(queryParams),
    placeholderData: keepPreviousData
  });

  const total = data ? Math.ceil(data.count / limit) : 1;

  const nextPage = () => {
    if (page < total - 1) setPage((page) => page + 1);
  };

  const previousPage = () => {
    if (page > 0) setPage((page) => page - 1);
  };

  return {
    data,
    error: isError,
    isPending,
    isLoading: isPending,
    loading: isPending,
    nextPage,
    previousPage,
    total,
    page,
    setPage,
    isFetching,
    refetch,
  };
}
